import { api } from '../hooks/useApi';

export interface UpdateProfileResponse {
  success: boolean;
  message: string;
  data: { user: any };
}

export const updateProfile = async (form: FormData): Promise<UpdateProfileResponse> => {
  return api.patchForm<UpdateProfileResponse>('/api/auth/profile/', form);
};
